<div class="fv-container">
  <div class="left-panel">
    <div class="row header gap-1 d-flex m-0 align-items-center justify-content-between">
      <div class="col-1">
        <img [src]="icon" alt="img/default_entity.png" width="42" height="42" class="entity-window-icon">
      </div>
      <div class="col-7 fs-6">
        <div class="details-name yellow-title">{{ this.floorMapEntity?.name }}</div>
        <div class="details-label">
          {{ isIncidentRunning() ? formatDate(currentRunningTime) : (!isEmpty(getCurrentIncident()?.timestamp) ?
          formatDate(getCurrentIncident()?.timestamp) : formatDate(getNow())) }}
        </div>
        @if (showStaticCoordinates()) {
        <div class="details-label">
          Lat: {{ round(this.latitude) }} Lon: {{ round(this.longitude) }}
        </div>
        }
        @if (showTemporalCoordinates()) {
        <div class="details-label">
          Lat: {{ round(tempLat) }} Lon: {{ round(tempLong) }}
        </div>
        }
      </div>
      <div class="col-2 text-end">
        <button class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
      </div>
    </div>
    <div class="floor-view-container">
      <div class="row">
        <div class="col-3">
          <div class="fs-6">Floor View</div>
        </div>
        <div class="col-4">
          <div class="fs-6">Incident time: </div>
        </div>
        <div class="col-5">
          <div class="fs-6"><i>{{getCurrentIncidentTime()}}</i></div>
        </div>
      </div>
      <div class="toggle-bar">
        <label>
          <input type="checkbox" checked (change)="changeCameraClick($event)" /> Camera {{ numberOfCameras }}
        </label>
        <label>
          <input type="checkbox" [(ngModel)]="showAccessControlLayer" (change)="showHideAccessControlLayer()"
            style="margin-left: 10px" /> Sensor ({{ numberOfAccessControls }})
        </label>
        <label *ngIf="numberOfRaspberryPis > 0">
          <input type="checkbox" [(ngModel)]="showRaspberryPiLayer" (change)="showHideRaspberryPiLayer()"
            style="margin-left: 10px" /> Raspberry Pi ({{ numberOfRaspberryPis }})
        </label>
        <label>
          <input type="checkbox" [checked]="beaconsVisible" (change)="changeBeacons($event)" /> Beacon {{
          numberOfBeacons }}
        </label>
      </div>
      <div class="toggle-bar" style="margin-top: 5px;">
        <label>
          <input type="checkbox" (change)="changeBlenderView($event)" /> Blender View
        </label>
        @if (blenderViewEnabled) {
        <button type="button" class="btn btn-sm btn-light" (click)="openFullScreenModal()">
          <i class="fa-solid fa-expand"></i> Full Screen
        </button>
        }
      </div>

      <div class="map-area" [class.blender-active]="blenderViewEnabled">
        <div class="map-stack">
          <app-floor-map [class.fullscreen-map-bg]="isFullScreenBlender" [suppressThreeOverlay]="blenderViewEnabled"
            [dangerChecked]="data.dangerChecked" [safeChecked]="data.safeChecked" [unknownChecked]="data.unknownChecked"
            [suspectChecked]="data.suspectChecked" [showBeacons]="beaconsVisible" [showCameraLayer]="cameraVisible"
            [showAccessControlLayer]="showAccessControlLayer"
            [showRaspberryPiLayer]="showRaspberryPiLayer || activeTab === 'raspberry-pi'"
            [showDeviceMarkers]="showRaspberryPiLayer || activeTab === 'raspberry-pi' || activeTab === 'devices'"
            [show3DUserClusters]="data.show3DUserClusters" (perimeterChange)="perimeterChange($event)"
            (userOnFloorsChange)="userOnFloorsChange($event)" (numberOfBeaconsChange)="numberOfBeaconsChange($event)"
            (numberOfCamerasChange)="numberOfCamerasChange($event)" (cameraLayerChange)="cameraLayerChange($event)"
            (numberOfAccessControlsChange)="numberOfAccessControlsChange($event)"
            (accessControlLayerChange)="accessControlLayerChange($event)"
            (numberOfRaspberryPisChange)="numberOfRaspberryPisChange($event)"
            (raspberryPiLayerChange)="raspberryPiLayerChange($event)"
            (raspberryPiMarkerClick)="onRaspberryPiMarkerClick($event)"
            (deviceMarkerClick)="onDeviceMarkerClick($event)"
            (numberOfDevicesWithCoordsChange)="onNumberOfDevicesWithCoordsChange($event)"
            [raspberryPiDevices]="getEffectiveDevicesForMap()"
            [raspberryPiDeviceCount]="raspberryPiTotal || getEffectiveDevicesForMap().length"
            [raspberryPiSensorCounts]="raspberryPiSensorCounts"
            (updateChanges)="updateChanges($event)" (collapseChange)="onMapCollapseChange($event)"
            (userClicked)="onUserClicked($event)" (floorUserDevicesRaw)="onFloorUserDevicesRaw($event)"
            [floorMapEntity]="floorMapEntity" [assetResolutionKey]="assetResolutionKey"></app-floor-map>
          <div class="blender-view-host" [class.fullscreen]="isFullScreenBlender"
            [style.display]="blenderViewEnabled ? 'block' : 'none'">
            @if (blenderViewLoading) {
            <div class="blender-loading-overlay">
              <i class="fa-solid fa-spinner fa-spin"></i>
              <span>Loading 3D Floor...</span>
            </div>
            }
            <app-blender-floor-viewer class="blender-floor-overlay" [class.blender-building-hidden]="blenderViewLoading"
              [class.is-visible]="blenderViewEnabled" [class.fullscreen-overlay]="isFullScreenBlender"
              [useSharedLeafletBackground]="true" [mapVisible]="blenderViewEnabled"
              [syncLeafletView]="sidebarLeafletView" [floorMapEntity]="floorMapEntity"
              [liveUserData]="blenderLiveUserData" [liveUserAssetConfig]="{ showClusters: data.show3DUserClusters }"
              [assetResolutionKey]="assetResolutionKey" [alertRecords]="alertRecords" [showBeacons]="beaconsVisible"
              (loadingChange)="onBlenderLoadingChange($event)" (userClicked)="onUserClicked($event)"
              (roomClicked)="onBlenderRoomClicked($event)">
            </app-blender-floor-viewer>
          </div>
        </div>

        @if (isFullScreenBlender) {
        <app-glb-floor-view #glbFloorView [floorMapEntity]="floorMapEntity" [liveData]="liveData"
          [blenderLiveUserData]="blenderLiveUserData" [assetResolutionKey]="assetResolutionKey"
          [alertRecords]="alertRecords" [blenderViewLoading]="blenderViewLoading"
          [blenderViewEnabled]="blenderViewEnabled" [fullUsers]="fullUsers" [sidebarLeafletView]="sidebarLeafletView"
          [data]="data" [perimeters]="perimeters" [showBeacons]="beaconsVisible" (close)="closeFullScreenModal()"
          (userClicked)="onUserClicked($event)" (userSidebarClicked)="showUserInfoForGlb($event)"
          (toggleUserVisibility)="toggleUserVisibility($event)"
          (loadingChange)="onBlenderLoadingChange($event)"></app-glb-floor-view>
        }
      </div>

      @if (showTabs) {
      <div class="action-buttons nav nav-tabs mb-3">
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'user' }" (click)="selectTab('user')"
          type="button">
          Users
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'updates' }"
          (click)="selectTab('updates')" type="button">
          Updates
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'perimeters' }"
          (click)="selectTab('perimeters')" type="button">
          Perimeters
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'cameras' }"
          (click)="selectTab('cameras')" type="button">
          Cameras
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'raspberry-pi' }"
          (click)="selectTab('raspberry-pi')" type="button">
          Raspberry Pi
        </button>
        <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'devices' }"
          (click)="selectTab('devices')" type="button">
          Devices
        </button>
        <!-- <button class="btn btn-outline-primary" [ngClass]="{ active: activeTab === 'wifi-devices' }"
          (click)="activeTab = 'wifi-devices'" type="button">
          WiFi
        </button> -->
      </div>
      }

      <!-- Tab content -->
      @if (showTabs) {
      <div class="tab-content">
        @if (activeTab === 'user') {
        <div class="tab-pane fade show active">
          <div class="jumbotron no-padding-jumbo px-2 mt-2">
            <div class="row">
              <div class="filterControlWrap"
                style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;">
                <!-- Total Users and Controls -->
                <div
                  style="display: flex; align-items: center; gap: 10px; flex-direction: column; align-items: flex-start;">
                  <div style="display:flex; align-items:center; gap:10px; font-size: 14px;">
                    <span>Total: {{ data.totalUserCount }}</span>
                    @if (enableInteraction) {
                    <i class="fa fa-envelope icon-size" (click)="sendMessageForFloor()" title="Send message">
                    </i>
                    }
                    <i class="fa-solid fa-earth-asia icon-size" (click)="toggle3DUserClusters()"
                      [style.opacity]="data.show3DUserClusters ? 1 : 0.4" title="Toggle user clusters in 3D">
                    </i>
                  </div>
                </div>
                <!-- User Status Checkboxes -->
                <div class="user-status-checkboxes" style="display: flex; align-items: center; gap: 10px;">
                  <!-- Danger -->
                  <label class="status-item">
                    <input type="checkbox" [(ngModel)]="data.dangerChecked" (ngModelChange)="statusChanged()" />
                    <img src="assets/img/arcangel/user_in_danger.svg" style="width: 18px; height: 18px" />
                    {{data.dangerCount}}
                    @if (enableInteraction) {
                    <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('DANGER')"
                      style="cursor: pointer"></i>
                    }
                  </label>
                  <!-- Safe -->
                  <label class="status-item">
                    <input type="checkbox" [(ngModel)]="data.safeChecked" (ngModelChange)="statusChanged()" />
                    <img src="assets/img/arcangel/user_safe.svg" style="width: 18px; height: 18px" />
                    {{data.safeCount}}
                    @if (enableInteraction) {
                    <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('SAFE')"
                      style="cursor: pointer"></i>
                    }
                  </label>
                  <!-- Unknown -->
                  <label class="status-item">
                    <input type="checkbox" [(ngModel)]="data.unknownChecked" (ngModelChange)="statusChanged()" />
                    <img src="assets/img/arcangel/user_unknown.svg" style="width: 18px; height: 18px" />
                    {{data.unknownCount}}
                    @if (enableInteraction) {
                    <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('UNKNOWN')"
                      style="cursor: pointer"></i>
                    }
                  </label>
                  <!-- Suspect -->
                  <label class="status-item d-none">
                    <input type="checkbox" [(ngModel)]="data.suspectChecked" (ngModelChange)="statusChanged()" />
                    <img src="assets/img/arcangel/user_suspect.svg" style="width: 18px; height: 18px" />
                    {{data.suspectCount}}
                    @if (enableInteraction) {
                    <i class="fa fa-envelope icon-size" (click)="sendMessageToUsers('SUSPECT')"
                      style="cursor: pointer"></i>
                    }
                  </label>
                </div>
              </div>
            </div>
            <div class="border-line"></div>
            <div class="filter-result-block mb-2">Filtered Results: Total {{ data.totalUserCount }} (page
              {{ data.page }} of {{ data.lastPage }})</div>
            <div class="tableScroll">
              <table class="w-100">
                <tr>
                  <td class="user-table-td">
                    @for (user of data.userList1; track user) {
                    <div class="p-0">
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (user.visible) {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                  <td class="user-table-td">
                    @for (user of data.userList2; track user) {
                    <div>
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (user.visible) {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                  <td class="user-table-td">
                    @for (user of data.userList3; track user) {
                    <div>
                      {{ user.name }}
                      <img [src]="user.src" style="width: 12px; height: 12px" />
                      @if (user.visible) {
                      <img src="assets/img/eyeVisible.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (!user.visible) {
                      <img src="assets/img/eyeHidden.svg" (click)="toggleUserVisibility(user)" class="user-icon" />
                      }
                      @if (user.visible) {
                      <i class="fa fa-info-circle" (click)="showUserInfo(user)"
                        style="margin-left: 5px; padding-top: 5px"></i>
                      }
                    </div>
                    }
                  </td>
                </tr>
              </table>
            </div>
            <div class="d-flex justify-content-end mt-2 me-2">
              @if (data.page > 1) {
              <span (click)="jumpPage(-1)" class="cursor-pointer me-3"><i class="fa fa-chevron-left"></i>Previous</span>
              }
              <span class="me-3">Page {{ data.page }}</span>
              @if (data.page < data.lastPage) { <span (click)="jumpPage(1)" class="cursor-pointer">Next <i
                  class="fa fa-chevron-right"></i></span>
                }
            </div>
          </div>
        </div>
        }
        @if (activeTab === 'updates') {
        <div class="tab-pane fade show active">
          <div class="scrollbar-primary custom-scroll">
            <table class="table custom-table bg-none">
              <tr class="fs-5 fw-bold">
                <td>
                  @if (enableInteraction) {
                  <img src="assets/img/arcangel/add_update.svg" alt="Add Update" width="40" height="40"
                    title="Add Update" (click)="addUpdate()" class="m-2 cursor-pointer">
                  }
                </td>
                <td>Sender</td>
                <td>Time</td>
                <td>Title</td>
              </tr>
              @for (update of updates; track update) {
              <tr class="demo-cell-hover fs-6" (click)="showIncidentUpdateWindow(update)">
                <td>
                  <img [src]="update?.icon" class="update-icon cursor-pointer" [title]="update?.data?.status">
                </td>
                <td>{{ update?.data?.userInfo?.name || 'unknown' }}</td>
                <td>{{ update?.localTime }}</td>
                <td>{{ update?.name }}</td>
              </tr>
              }
            </table>
          </div>
        </div>
        }
        @if (activeTab === 'perimeters') {
        <div class="tab-pane custom-scroll fade show active">
          @for (perimeter of perimeters; track perimeter) {
          <div>
            <div class="floor-summary">
              <div class="floor-row">
                <div class="floor-label">{{ perimeter.name }}</div>
                <span>
                  <span class="label label-pill label-warning floor-status-badges"
                    [ngClass]="{ 'zero-number-badge': getNumberOfUnknownUsersForPerimeter(perimeter) === 0 }">
                    {{ getNumberOfUnknownUsersForPerimeter(perimeter) }}
                  </span>
                  <span class="label label-pill label-success floor-status-badges"
                    [ngClass]="{ 'zero-number-badge': getNumberOfSafeUsersForPerimeter(perimeter) === 0 }">
                    {{ getNumberOfSafeUsersForPerimeter(perimeter) }}
                  </span>
                  <span class="label label-pill label-danger floor-status-badges"
                    [ngClass]="{ 'zero-number-badge': getNumberOfUnSafeUsersForPerimeter(perimeter) === 0 }">
                    {{ getNumberOfUnSafeUsersForPerimeter(perimeter) }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          }
        </div>
        }
        @if (activeTab === 'cameras') {
        <div class="tab-pane fade show active">
          <table class="camera-table">
            <thead>
              <tr>
                <th>Camera Name</th>
                <th>Room</th>
              </tr>
            </thead>
            <tbody>
              @for (camera of cameraListForFloor; track camera.id) {
              <tr>
                <td>{{ camera.label }}</td>
                <td>{{ camera.room.label }}</td>
                <td class="actions">
                  <button type="button" class="btn btn-icon" (click)="viewInfo(camera)" title="Info"><i
                      class="fas fa-info"></i></button>
                  <button type="button" class="btn btn-icon" (click)="viewCamera(camera)" title="Play"><i
                      class="fas fa-play"></i></button>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
        @if (activeTab === 'raspberry-pi') {
        <div class="tab-pane fade show active">
          <div class="scrollbar-primary custom-scroll rpi-container px-2 pt-2">
            <!-- Header bar with Title, Count, Live Status, and Refresh -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="d-flex align-items-center gap-2">
                <span class="rpi-title">Raspberry Pi</span>
                <span class="badge rpi-count-badge"
                  *ngIf="!raspberryPiLoading && (getAllTransportCount() > 0 || raspberryPiTotal > 0 || raspberryPiDevices.length > 0)">
                  {{ getActiveCountBadgeText() }}
                </span>
              </div>
              <div class="d-flex align-items-center gap-2">
                <div class="rpi-live-indicator"
                  *ngIf="!raspberryPiLoading && (raspberryPiTotal > 0 || raspberryPiDevices.length > 0)">
                  <span class="rpi-pulse-dot"></span>
                  <span class="rpi-live-text">Live</span>
                </div>
                <button class="btn btn-sm btn-outline-secondary text-white rpi-refresh-btn"
                  (click)="fetchRaspberryPiDevices()" [disabled]="raspberryPiLoading" title="Refresh devices">
                  <i class="fa fa-refresh" [class.fa-spin]="raspberryPiLoading"></i> Refresh
                </button>
              </div>
            </div>

            <!-- Transport Filters (BLE & WiFi) -->
            <div class="rpi-platform-pills mb-2">
              <span class="rpi-filter-pill" [class.active]="selectedTransportFilter === 'ALL'"
                (click)="onSelectTransportFilter('ALL')">
                All ({{ getAllTransportCount() | number }})
              </span>
              <span class="rpi-filter-pill pill-ble" [class.active]="selectedTransportFilter === 'BLE'"
                (click)="onSelectTransportFilter('BLE')">
                <i class="fa-brands fa-bluetooth-b"></i> BLE ({{ getTransportCount('BLE') | number }})
              </span>
              <span class="rpi-filter-pill pill-wifi" [class.active]="selectedTransportFilter === 'WIFI'"
                (click)="onSelectTransportFilter('WIFI')">
                <i class="fa-solid fa-wifi"></i> WiFi ({{ getTransportCount('WIFI') | number }})
              </span>
              <ng-container *ngFor="let t of getDistinctOtherTransports()">
                <span class="rpi-filter-pill" [class.active]="selectedTransportFilter.toUpperCase() === t.toUpperCase()"
                  (click)="onSelectTransportFilter(t)">
                  {{ t }} ({{ getTransportCount(t) | number }})
                </span>
              </ng-container>
            </div>

            <!-- Search Box & Time Range Dropdown -->
            <div class="rpi-search-box mb-2">
              <div class="d-flex align-items-center gap-2">
                <div class="rpi-search-input-group flex-grow-1">
                  <i class="fa fa-search rpi-search-icon"></i>
                  <input class="rpi-search-input" type="text" [(ngModel)]="raspberryPiSearchQuery"
                    placeholder="Filter by name, MAC, or transport..." />
                  <button *ngIf="raspberryPiSearchQuery" class="rpi-clear-search-btn"
                    (click)="raspberryPiSearchQuery = ''">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="d-flex align-items-center gap-1 rpi-time-wrapper">
                  <i class="fa-solid fa-clock text-white-50" style="font-size: 0.72rem;"></i>
                  <select class="rpi-time-select" [ngModel]="selectedTimeRange"
                    (ngModelChange)="onSelectTimeRange($event)" title="Change Last Seen filter">
                    <option value="5min">Last 5 min</option>
                    <option value="10min">Last 10 min</option>
                    <option value="30min">Last 30 min</option>
                    <option value="1hour">Last 1 hr</option>
                    <option value="all">All Time</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Loading State -->
            <div *ngIf="raspberryPiLoading" class="text-center py-4 text-white-50">
              <div class="spinner-border spinner-border-sm text-primary mb-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div style="font-size: 13px;">Scanning Raspberry Pi devices...</div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!raspberryPiLoading && getFilteredRaspberryPiDevices().length === 0"
              class="text-center py-4 text-white-50">
              <i class="fa fa-microchip mb-2" style="font-size: 1.8rem; opacity: 0.5;"></i>
              <div style="font-size: 13px;">
                {{ raspberryPiSearchQuery ? 'No devices match your search' : 'No Raspberry Pi devices found' }}
              </div>
              <div class="text-white-50 mt-1" style="font-size: 11px;" *ngIf="selectedTimeRange !== 'all'">
                Filtered by {{ selectedTimeRange === '5min' ? 'last 5 minutes' : (selectedTimeRange === '10min' ? 'last
                10 minutes' : (selectedTimeRange === '30min' ? 'last 30 minutes' : (selectedTimeRange === '1hour' ?
                'last 1 hour' : selectedTimeRange))) }}
              </div>
              <button *ngIf="selectedTimeRange !== 'all'" class="btn btn-sm btn-link text-info mt-1"
                (click)="onSelectTimeRange('all')">
                View all time
              </button>
              <button
                *ngIf="selectedTimeRange === 'all' && (raspberryPiSearchQuery || selectedPlatformFilter !== 'ALL' || selectedTransportFilter !== 'ALL')"
                class="btn btn-sm btn-link text-info mt-1" (click)="clearRaspberryPiFilters()">
                Clear filter
              </button>
            </div>

            <!-- Device Cards List -->
            <div *ngIf="!raspberryPiLoading && getFilteredRaspberryPiDevices().length > 0" class="rpi-cards-list">
              <div class="rpi-device-card" *ngFor="let device of getFilteredRaspberryPiDevices()"
                (click)="onDeviceCardClick(device)" [class.selected-device]="selectedDevice?.id === device.id"
                [attr.data-device-id]="device.id">
                <!-- Device Avatar -->
                <div class="rpi-avatar"
                  [ngClass]="getDeviceAvatarClass(device?.platform, device?.device_name || device?.name, device?.transport)">
                  <i
                    [class]="getDeviceIconClass(device?.platform, device?.device_name || device?.name, device?.transport)"></i>
                </div>

                <!-- Details Column -->
                <div class="rpi-details">
                  <div class="rpi-top-row">
                    <span class="rpi-device-name" [title]="device?.device_name || device?.name || 'Unknown Device'">
                      {{ device?.device_name || device?.name || 'Unknown Device' }}
                    </span>
                    <div class="rpi-badges">
                      <!-- Coordinates Badge -->
                      <span class="badge rpi-coords-badge" *ngIf="hasCoordinates(device)"
                        [title]="'Location on map: ' + (device.coordinates ? device.coordinates[0] + ', ' + device.coordinates[1] : 'Available')">
                        <i class="fa-solid fa-location-dot"></i>
                      </span>
                      <!-- Transport Badge (BLE / WiFi) -->
                      <span class="badge rpi-platform-badge" [ngClass]="getTransportBadgeClass(device?.transport)"
                        *ngIf="device?.transport">
                        {{ (device.transport || '').toUpperCase() === 'BLE' ? 'BLE' : ((device.transport ||
                        '').toUpperCase() === 'WIFI' ? 'WiFi' : device.transport) }}
                      </span>
                      <!-- Platform Badge fallback if no transport -->
                      <span class="badge rpi-platform-badge" [ngClass]="getPlatformBadgeClass(device?.platform)"
                        *ngIf="!device?.transport && device?.platform && device?.platform !== 'Other'">
                        {{ device?.platform }}
                      </span>
                      <span class="badge rpi-rssi-badge" [ngClass]="getRssiBadgeClass(device?.rssi)"
                        [title]="'RSSI: ' + (device?.rssi != null ? device.rssi + ' dBm' : 'N/A')">
                        <i class="fa fa-signal"></i> {{ device?.rssi != null ? device.rssi : 'N/A' }}
                      </span>
                    </div>
                  </div>
                  <div class="rpi-bottom-row">
                    <span class="rpi-mac" [title]="'MAC: ' + (device?.address || 'N/A')">
                      <i class="fa fa-network-wired me-1"></i>{{ device?.address || 'N/A' }}
                    </span>
                    <span class="rpi-meta-item" *ngIf="device?.manufacturer_id || device?.manufacturerId"
                      [title]="'Manufacturer: ' + (device?.manufacturer_id || device?.manufacturerId)">
                      <i class="fa fa-microchip me-1"></i>{{ device?.manufacturer_id || device?.manufacturerId }}
                    </span>
                    <span class="rpi-time"
                      [title]="(device?.last_seen || device?.lastSeen) ? formatDate(device.last_seen || device.lastSeen) : ''">
                      <i class="fa fa-clock me-1"></i>{{ formatLastSeen(device?.last_seen || device?.lastSeen) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div class="d-flex justify-content-between align-items-center pt-2 mt-2 border-top border-secondary"
              *ngIf="!raspberryPiLoading && (raspberryPiTotal > 0 || raspberryPiDevices.length > 0)">
              <span class="text-white-50" style="font-size: 12px;">
                Showing {{ getFilteredRaspberryPiDevices().length }} of {{ (raspberryPiTotal ||
                raspberryPiDevices.length) | number }} devices
              </span>
              <div class="d-flex align-items-center gap-1" *ngIf="raspberryPiTotalPages > 1">
                <button type="button" class="btn btn-sm btn-outline-secondary text-white py-0 px-2"
                  [disabled]="raspberryPiPage <= 1" (click)="raspberryPiPrevPage()" title="Previous page">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <span class="text-white px-1" style="font-size: 12px;">
                  Page {{ raspberryPiPage }} of {{ raspberryPiTotalPages }}
                </span>
                <button type="button" class="btn btn-sm btn-outline-secondary text-white py-0 px-2"
                  [disabled]="raspberryPiPage >= raspberryPiTotalPages" (click)="raspberryPiNextPage()"
                  title="Next page">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        }
        @if (activeTab === 'wifi-devices') {
        <div class="tab-pane fade show active">
          <div class="scrollbar-primary custom-scroll px-2 mt-2">
            <app-wifi-devices></app-wifi-devices>
          </div>
        </div>
        }
        @if (activeTab === 'devices') {
        <div class="tab-pane fade show active">
          <div class="scrollbar-primary custom-scroll devices-tab-pane px-2 pt-1">
            <app-ble-wifi-devices [floorMapEntity]="floorMapEntity"
              [buildingPerimeterIds]="getAllBuildingPerimeterIds()" [incidentId]="getBuildingIncidentId()"
              [active]="activeTab === 'devices'" (devicesChange)="onBleWifiDevicesChange($event)"
              (deviceSelect)="onBleWifiDeviceSelect($event)">
            </app-ble-wifi-devices>
          </div>
        </div>
        }
      </div>
      }
    </div>

    <div>
      <div class="icon-bar">
        <div class="footer-icon-row gap-5">
          @for (command of commands; track command; let i = $index) {
          <img [src]="command.icon" alt="Command icon" class="footer-icon" (click)="onCommandClick(i,floorMapEntity)" />
          }
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noUsersModal let-modal>
  <div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div>
      <span class="session-header-title">Notification</span>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="modal.dismiss()">×</button>
  </div>
  <div class="modal-body">
    <label>No users to notify</label>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Ok</button>
  </div>
</ng-template>

<ng-template #fullScreenModal let-modal>
  <div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div>
      <span class="session-header-title">Full Screen Floor View - {{ floorMapEntity?.name }}</span>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="closeFullScreenModal()">×</button>
  </div>
  <div class="modal-body p-0" style="height: 70vh; position: relative;">
    <div class="blender-view-host" style="width: 100%; height: 100%;">
      @if (blenderViewLoading) {
      <div class="blender-loading-overlay">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Loading 3D building...</span>
      </div>
      }
      <app-blender-floor-viewer class="blender-floor-overlay" [class.blender-building-hidden]="blenderViewLoading"
        [class.is-visible]="blenderViewEnabled" [floorMapEntity]="floorMapEntity" [liveUserData]="blenderLiveUserData"
        [liveUserAssetConfig]="{showClusters: data.show3DUserClusters}" [assetResolutionKey]="assetResolutionKey"
        [alertRecords]="alertRecords" [showResetCamera]="false" [showBeacons]="beaconsVisible"
        (loadingChange)="onBlenderLoadingChange($event)" (userClicked)="onUserClicked($event)">
      </app-blender-floor-viewer>
    </div>
  </div>
</ng-template>
@if (showGlobeClick) {
<div
  class="location-palette-container globe-click-modal modal-bottom d-flex align-items-center justify-content-between">
  <div class="d-flex">
    <div class="m-3 text-white">Click anywhere on the globe to create an incident update.</div>
    <button type="button" class="close-button" aria-label="Close" (click)="onGlobeClickClose()">×</button>
  </div>
</div>
}